module.exports = __webpack_public_path__ + "media/images/lazy-placeholder-4e444fdc.png";